export const serviceInfo = [
  {
    "category": "服务承诺",
    "items": [
      "师傅原因免费处理",
      "保修3个月",
      "免费平移",
      "2小时内预约",
      "准时上门",
      "二次费用30",
      "不乱收费/不随便加价",
      "服务信息保密",
      "处理不好不收费",
      "自愿配合返件",
      "免费现场邀评",
      "服务中其它小问题免费处理"
    ]
  },
]
export const skills = [
  {
    "category": "增值服务",
    "items": [
      "送货",
      "安装",
      "维修",
      "上楼",
      "打包",
      "返货",
      "保养",
      "清洗",
    ]
  },
  {
    "category": "平台技能",
    "items": [
      "按摩椅",
      "按摩床",
      "跑步机",
      "椭圆机",
      "动感单车",
      "电脑/网络布线",
      "手机数码",
      "净水器",
      "电视/投影仪",
      "冰箱",
      "洗衣机",
      "空调",
      "晾衣架/窗帘",
      "上门洗车",
      "门禁/监控",
      "地板/瓷砖",
      "门窗",
      "充电桩",
      "牌匾灯箱",
      "墙纸地毯",
    ]
  },
  {
    "category": "分类",
    "items": [
      "家电",
      "家具",
      "灯具",
      "锁具",
      "健身器材",
      "厨房卫浴",
      "智能家居",
      "水电线路",
      "拆旧/旧物处理",
      "办公设备",
      "乐器/体育器材",
      "供暖设备",
      "皮具养护",
      "洗衣护理",
      "家电清洗",
      "清洁杀菌",
      "上门做饭",
      "收纳整理",
      "保姆月嫂",
      "保洁清洗",
      "搬家拉货",
      "生活配送",
      "管道疏通",
      "防水补漏",
      "户外设施",
    ]
  },
]